<template>
  <div v-if="getUser">
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">{{ $t("Receivewith") }} QR-Code</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="container-center lg animated fadeIn">
      <div class="text-center">
        <p>{{ $t("Generate") }} QR-Code {{ $t("forreceive") }}</p>
        <qrcode
          v-model="getUser.email"
          :options="{ size: 150 }"
          class="img-thumbnail"
        ></qrcode>
        <form class="form-horizontal">
          <div class="form-group">
            <label for="address" class="col-xs-4 control-label"
              >{{ $t("PaymentURL") }}:</label
            >
            <div class="col-xs-8">
              <input
                id="factor"
                type="factor"
                v-model="link"
                class="form-control"
                placeholder="Loading..."
              />
            </div>
          </div>
        </form>
      </div>

      <div class="panel panel-filled">
        <div class="panel-body">
          <p class="text-center">You can change amount to receive</p>
          <form class="form-horizontal">
            <div class="form-group">
              <label for="Currency" class="col-xs-4 control-label">{{
                $t("Currency")
              }}</label>
              <div class="col-xs-8">
                <select id="Currency" v-model="currency" class="form-control">
                  <option
                    class="coin"
                    v-for="c in getCurrency"
                    v-bind:key="c.id"
                    v-bind:value="c.coin"
                    >{{ c.coin }}</option
                  >
                </select>
              </div>
            </div>
            <div class="form-group">
              <label for="address" class="col-xs-4 control-label">{{
                $t("Email")
              }}</label>
              <div class="col-xs-8">
                <input
                  id="address"
                  type="text"
                  v-model="address"
                  class="form-control"
                  placeholder=""
                />
              </div>
            </div>
            <div class="form-group">
              <label for="amount" class="col-xs-4 control-label">{{
                $t("Amount")
              }}</label>
              <div class="col-xs-8">
                <input
                  id="amount"
                  type="number"
                  v-model="amount"
                  class="form-control"
                />
                <span class="unit">{{ currency }}</span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SITE_URL } from "../../config";
import Vue from "vue";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import { mapGetters } from "vuex";

Vue.component(VueQrcode.name, VueQrcode);

export default {
  data() {
    return {
      link: null,
      currency: "BTC",
      address: null,
      amount: 0
    };
  },
  created() {
    this.address = this.getUser.email;
    this.link = SITE_URL + "/transfer/BTC/" + this.getUser.email + "/0";
  },
  computed: mapGetters(["getCurrency", "getUser"]),
  watch: {
    amount: function() {
      this.link =
        SITE_URL +
        "/transfer/" +
        this.currency +
        "/" +
        this.address +
        "/" +
        this.amount;
    },
    address: function() {
      this.link =
        SITE_URL +
        "/transfer/" +
        this.currency +
        "/" +
        this.address +
        "/" +
        this.amount;
    },
    currency: function() {
      this.link =
        SITE_URL +
        "/transfer/" +
        this.currency +
        "/" +
        this.address +
        "/" +
        this.amount;
    }
  }
};
</script>
